// src/components/PureMadnessSection.jsx
import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../services/firebase";
import ProductCard from "./ProductCard"; // Fixed the import path!
import { Link } from "react-router-dom";

const PureMadnessSection = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, "products"));
                const productList = [];
                querySnapshot.forEach((doc) => {
                    productList.push({ id: doc.id, ...doc.data() });
                });
                setProducts(productList);
            } catch (err) {
                setError("Failed to load the exclusive collection.");
            } finally {
                setLoading(false);
            }
        };
        fetchProducts();
    }, []);

    const rawBundles = products.filter(p => p.category === "Pure Madness - Bundles");
    const rawFrontals = products.filter(p => p.category === "Pure Madness - Frontals");

    const scrollToCategory = (categoryId) => {
        const element = document.getElementById(categoryId);
        if (element) {
            const y = element.getBoundingClientRect().top + window.scrollY - 100;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    };

    if (loading) return (
        <div className="container py-5 text-center">
            <div className="spinner-border text-primary" style={{ color: "#d4af37" }} role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-2" style={{ color: "rgba(245,240,232,0.5)", letterSpacing: "2px", textTransform: "uppercase", fontSize: "0.8rem" }}>Loading Collection...</p>
        </div>
    );
    if (error) return <div className="container py-5 text-center text-danger"><p>{error}</p></div>;

    return (
        <section className="container py-5">
            {/* Quick Navigation Bar (Forced to always show) */}
            <div style={{
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                gap: "15px",
                marginBottom: "50px",
                paddingBottom: "30px",
                borderBottom: "1px solid rgba(212, 175, 55, 0.15)"
            }}>
                <button onClick={() => scrollToCategory('category-raw-bundles')} className="btn-luxury-outline" style={{ padding: "10px 20px", fontSize: "0.65rem" }}>
                    Raw Bundles
                </button>
                <button onClick={() => scrollToCategory('category-raw-frontals')} className="btn-luxury-outline" style={{ padding: "10px 20px", fontSize: "0.65rem" }}>
                    Raw Frontals & Closures
                </button>
            </div>

            <h2 id="category-raw-bundles" className="section-title" style={{ color: "#d4af37", letterSpacing: "6px" }}>RAW BUNDLES</h2>
            <div className="row">
                {rawBundles.length > 0 ? (
                    rawBundles.map((product) => (
                        <div key={product.id} className="col-6 col-md-4 mb-4">
                            <Link to={`/product/${product.id}`} style={{ textDecoration: "none" }}>
                                <ProductCard product={product} />
                            </Link>
                        </div>
                    ))
                ) : (
                    <div className="col-12 text-center"><p className="text-muted" style={{ fontStyle: 'italic' }}>Raw bundles arriving soon.</p></div>
                )}
            </div>

            <h2 id="category-raw-frontals" className="section-title mt-5" style={{ color: "#d4af37", letterSpacing: "6px" }}>RAW FRONTALS & CLOSURES</h2>
            <div className="row">
                {rawFrontals.length > 0 ? (
                    rawFrontals.map((product) => (
                        <div key={product.id} className="col-6 col-md-4 mb-4">
                            <Link to={`/product/${product.id}`} style={{ textDecoration: "none" }}>
                                <ProductCard product={product} />
                            </Link>
                        </div>
                    ))
                ) : (
                    <div className="col-12 text-center"><p className="text-muted" style={{ fontStyle: 'italic' }}>Raw frontals arriving soon.</p></div>
                )}
            </div>
        </section>
    );
};

export default PureMadnessSection;